import { useMutation } from '@tanstack/react-query';

import { videoCallService, type StartRecordingResponse } from '../services';

/**
 * Mutation hook for POST /sessions/:id/call/recording/start.
 * Practitioner + super_admin only (enforced server-side). Backend
 * auto-starts recording when the room is first created, so this hook
 * is primarily used for Resume-after-Pause flows.
 */
export function useStartRecording() {
  return useMutation<StartRecordingResponse, Error, string>({
    mutationFn: (sessionId) => videoCallService.startRecording(sessionId),
  });
}
